<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>工讀生管理</h2>
      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li>
            <router-link to="/">
              <i class="fa fa-home"></i>
            </router-link>
          </li>
          <li><span>助學金管理系統</span></li>
          <li><span>工讀生管理</span></li>
          <li><span>工讀生清單</span></li>
          <li><span>工作記錄表</span></li>
        </ol>
      </div>
    </header>
    <!-- start: page -->
    <div id="tabs-02" class="row">
      <div id="tabs-04" class="row">
        <div class="col-md-12">
          <section class="panel">
            <div class="panel-body">
              <div class="s_tenr" align="right">
                <router-link to="/student/schedule" class="btn-upload btn btn-primary">工讀班表</router-link>
              </div>
              <table ref="table" class="table table-no-more table-bordered table-striped mb-none">
                <thead>
                  <tr>
                    <th class="text-center" width="5%">筆數</th>
                    <th class="text-center" width="10%">帳號狀態</th>
                    <th class="text-center" width="10%">類型</th>
                    <th class="text-center" width="15%">申請單位</th>
                    <th class="text-center" width="12%">姓名</th>
                    <th class="text-center" width="13%">學號</th>
                    <th class="text-center" width="15%">聘僱期間</th>
                    <th class="text-center" width="10%">聘用資料</th>
                    <th class="text-center" width="10%">離職申請</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in list" :key="index">
                    <td data-title="筆數" class="text-center">{{index + 1}}</td>
                    <td data-title="帳號狀態" class="text-center">{{item.accountStatus ? "啟用" : "停用"}}</td>
                    <td data-title="類型" class="text-center">{{item.workstudyType}}</td>
                    <td data-title="申請單位" class="text-center">{{item.deptName}}</td>
                    <td data-title="工讀生姓名" class="text-center">{{item.studentName}}</td>
                    <td data-title="學號" class="text-center">{{item.studentId}}</td>
                    <td data-title="聘僱期間" class="text-center">{{item.workTime}}</td>
                    <td data-title="聘用資料" class="text-center">
                      <router-link v-if="item.workstudyType=='勞雇'" :to="'/student/employ/' + item.id">{{item.hasEmploy ? "已填寫" : "未填寫"}}</router-link>
                      <span v-else>無</span>
                    </td>
                    <td data-title="離職申請" class="text-center">
                      <router-link v-if="item.workstudyType=='勞雇'" :to="'/student/resign/' + item.id">{{item.hasResign ? "已填寫" : "未填寫"}}</router-link>
                      <span v-else>無</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      list: []
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      if ($.fn.DataTable.isDataTable(this.$refs.table)) {
        $(this.$refs.table).DataTable().destroy();
      }
      this.$http
        .get("/api/workstudyStudent")
        .then(a => {
          this.list = a.body;
          this.$nextTick(b => {
            $(this.$refs.table).DataTable({
              bFilter: false,
              bLengthChange: false,
              language: {
                info: "第 _PAGE_ 頁 / 總共 _PAGES_ 頁"
              },
              bSort: false,
              columns: [
                { width: "7%" },
                { width: "10%" },
                { width: "10%" },
                { width: "15%" },
                { width: "12%" },
                { width: "13%" },
                { width: "15%" },
                { width: "9%" },
                { width: "9%" }
              ]
            });
          });
        });
    },
  }
};
</script>

<style>
</style>